import { isFlexibleProfile } from './utils';
import { buildFacebookProps, formatFacebookServerProps, getNumberOfPetsRecipesAndMotivations, sendGoogleTagManagerEvent, trackAdWordsConversion, trackBingEvent, trackFacebookEvent, trackFriendBuyEvent, trackGoogleAnalyticsEvent, trackServerSideFacebookEvent, } from '@trackers';
import { DAYS_OF_FOOD_PER_INTERVAL_MAP, DELIVERY_INTERVALS, FUNNEL_VERSIONS_PRIORITY_MAP, } from '@variables';
var getFacebookPropsFromProfileData = function (profileData) {
    var daysOfFood = profileData.daysOfFood, deliveryInterval = profileData.deliveryInterval, orderCosts = profileData.orderCosts, pets = profileData.pets, petSurveys = profileData.petSurveys, version = profileData.version;
    var props = pets[0]
        ? buildFacebookProps(getNumberOfPetsRecipesAndMotivations(pets, petSurveys), pets[0], getCostPerWeek(orderCosts.subscriptionPlanSubtotal || orderCosts.subtotal, daysOfFood, version, deliveryInterval), version)
        : {};
    return props;
};
/* Normalizes cost to a weekly cost. */
var getCostPerWeek = function (costBeforeTaxAndPromo, daysOfFood, version, deliveryIntervalProp) {
    if (deliveryIntervalProp === void 0) { deliveryIntervalProp = DELIVERY_INTERVALS.BIWEEKLY; }
    // Build a bowl cost per week is calculated using daysOfFood derived from delivery interval
    if (isFlexibleProfile(version)) {
        var deliveryInterval = deliveryIntervalProp;
        daysOfFood = DAYS_OF_FOOD_PER_INTERVAL_MAP[deliveryInterval];
    }
    return parseFloat((costBeforeTaxAndPromo / (daysOfFood / 7)).toFixed(2));
};
/**
 * Fires on submit of the purchasing motivations form.
 */
var trackAddPurchasingMotivations = function (profileData, setFacebookSubscribeEventProps) {
    var props = getFacebookPropsFromProfileData(profileData);
    trackFacebookEvent('ViewContent', props, profileData.uuid);
    trackServerSideFacebookEvent('ViewContent', profileData.uuid, props);
    var formattedProps = formatFacebookServerProps(props);
    setFacebookSubscribeEventProps(formattedProps);
};
/**
 * Fires on landing on the meals form in the BAB funnel.
 */
var trackStartBuildABowl = function (profileData, setFacebookSubscribeEventProps) {
    var props = getFacebookPropsFromProfileData(profileData);
    trackFacebookEvent('AddToCart', props, profileData.uuid);
    var formattedProps = formatFacebookServerProps(props);
    trackServerSideFacebookEvent('AddToCart', profileData.uuid, props);
    setFacebookSubscribeEventProps(formattedProps);
};
/**
 * Fires on landing on the contact form.
 */
var trackProfileStart = function (profileData, setFacebookSubscribeEventProps) {
    trackAdWordsConversion('AW-936326366/oKtTCIu6vnMQ3um8vgM');
    trackBingEvent('profile started');
    trackGoogleAnalyticsEvent('profile started');
    var props = getFacebookPropsFromProfileData(profileData);
    trackFacebookEvent('AddToCart', props, profileData.uuid);
    var formattedProps = formatFacebookServerProps(props);
    trackServerSideFacebookEvent('AddToCart', profileData.uuid, props);
    setFacebookSubscribeEventProps(formattedProps);
};
/**
 * Fires on submit of the contact form.
 */
var trackCompleteContact = function (profileData) {
    window.LogRocket &&
        window.LogRocket.identify(profileData.uuid, {
            name: profileData.customerName,
            email: profileData.email,
        });
};
/**
 * Fires on landing on the address form.
 */
var trackAddressStart = function () {
    trackGoogleAnalyticsEvent('profile delivery address');
};
/**
 * Fires on submit of the address form.
 */
var trackCompleteAddress = function (profileData) {
    var props = getFacebookPropsFromProfileData(profileData);
    trackFacebookEvent('AddPaymentInfo', props, profileData.uuid);
    trackAdWordsConversion('AW-936326366/_UUQCMbo9GsQ3um8vgM');
    trackBingEvent('complete delivery address');
};
var getPaidTotal = function (orderCosts) {
    var totalPaid = orderCosts.costAfterPromo + orderCosts.salesTax;
    return parseFloat(totalPaid.toFixed(2));
};
var friendBuyReferralCode = function () {
    var urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('referralCode') || '';
};
/**
 * Fires on submit of the checkout form.
 */
var trackCreateAccount = function (profileData) {
    var customerName = profileData.customerName, email = profileData.email, hashedEmail = profileData.hashedEmail, orderCosts = profileData.orderCosts, uuid = profileData.uuid;
    trackFriendBuyEvent('purchase', uuid, {
        // Purchase Events in the FriendBuy docs call for an Order ID.
        // Because we only track the first Order, we opt to use the profile ID.
        amount: getPaidTotal(orderCosts),
        currency: 'USD',
        referralCode: friendBuyReferralCode(),
        isNewCustomer: true,
        customer: {
            id: uuid,
            email: email,
            name: customerName,
        },
    });
    sendGoogleTagManagerEvent({
        event: "click-next_summary_".concat(FUNNEL_VERSIONS_PRIORITY_MAP[profileData.version], "}"),
        customerName: customerName,
        costBeforeTaxAndPromo: orderCosts.subscriptionPlanSubtotal || orderCosts.subtotal,
        email: email,
        hashedEmail: hashedEmail,
        totalPaid: getPaidTotal(orderCosts),
        uuid: uuid,
    });
};
export { getFacebookPropsFromProfileData, trackAddPurchasingMotivations, trackAddressStart, trackCompleteAddress, trackCompleteContact, trackCreateAccount, trackProfileStart, trackStartBuildABowl, };
